angular
  .module('contrast.factory.login', [])
  .factory('LoginFactory', function ($, $http) {
    'ngInject'

    return {
      login: function (username, password, sso) {
        return $http({
          method: 'POST',
          url: '/Contrast/authenticate.html',
          //https://github.com/angular/angular.js/issues/6039
          // pass in data as strings
          data: $.param({
            ui: true,
            username: username,
            password: password,
            sso: sso
          }),
          // set the headers so angular passing info as form data (not request payload)
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        })
      }
    }
  })
